import { createApi } from '@reduxjs/toolkit/query/react'

import { getCustomFetch } from '@/shared/api/custom-fetch-base'
import { ERoleType } from '@/shared/enums'
import { IRole } from '@/shared/types/role'

const baseUrl = 'user/organization/roles/'

export const organizationRoleApi = createApi({
  reducerPath: 'organizationRoleApi',
  baseQuery: getCustomFetch(),
  tagTypes: ['organization-role-list'],
  endpoints: build => ({
    organizationRoleList: build.query<IRole[], string>({
      query: organization_id => ({
        url: `${baseUrl}?organization_id=${organization_id}`,
        method: 'GET',
      }),
      providesTags: ['organization-role-list'],
      transformResponse: (response: IRole[]) => {
        return response.map(role => ({
          ...role,
          role_type_id: ERoleType.organization,
          role_name: role.role_name ?? 'user',
          role_label: role.role_label ?? role.role_id,
        }))
      },
    }),
  }),
})

export const { useOrganizationRoleListQuery } = organizationRoleApi
